<template>
    <layouts-header></layouts-header>

    <cage-breadcrumb :title="title" :text="text" :text1="text1" />

    <coach-tabset></coach-tabset>

    <!-- Page Content -->
		<div class="content">
			<div class="container">
				<section class="card mb-40">
					<div class="text-center mb-40">
						<h3 class="mb-1">Order Confirmation</h3>
						<p class="sub-title">Booking confirmed. Contact support for changes/inquiries. Enjoy your coaching experience with us.</p>
					</div>
					<div class="master-academy dull-whitesmoke-bg card">
						<div class="d-sm-flex justify-content-between align-items-center">
							<div class="d-sm-flex justify-content-start align-items-center">
								<a href="javascript:void(0);"><img class="corner-radius-10" src="@/assets/img/profiles/avatar-02.png" alt="User"></a>
								<div class="info">
									<div class="d-flex justify-content-start align-items-center mb-3">
										<span class="text-white dark-yellow-bg color-white me-2 d-flex justify-content-center align-items-center">4.5</span>
										<span>300 Reviews</span>
									</div>
									<h3 class="mb-2">Kevin Anderson</h3>
									<p>Certified Badminton Coach with a deep understanding of the sport's  strategies.</p>
								</div>
							</div>
							<div class="white-bg">
								<p class="mb-1">Starts From</p>
								<h3 class="d-inline-block primary-text mb-0">$150</h3><span>/hr</span>
							</div>
						</div>
					</div>
				</section>
				<section class="card booking-order-confirmation">
					<h5 class="mb-3">Booking Details</h5>
					<ul class="booking-info d-lg-flex justify-content-start align-items-center">
						<li>
							<h6>Coach Name</h6>
							<p>Kevin Anderson</p>
						</li>
						<li>
							<h6>Appointment Date</h6>
							<p>Mon, Apr 27</p>
						</li>
						<li>
							<h6>Appointment Start time</h6>
							<p>05:25 AM</p>
						</li>
						<li>
							<h6>Appointment End time</h6>
							<p>06:25 AM</p>
						</li>
					</ul>
					<h5 class="mb-3">Contact  Information</h5>
					<ul class="contact-info d-lg-flex justify-content-start align-items-center">
						<li>
							<h6>Name</h6>
							<p>Rodick Tramliar</p>
						</li>
						<li>
							<h6>Contact Email Address</h6>
							<p>contact@example.com</p>
						</li>
						<li>
							<h6>Phone Number</h6>
							<p>+1 56565 556558</p>
						</li>
					</ul>
					<h5 class="mb-3">Payment Information</h5>
					<ul class="payment-info d-lg-flex justify-content-start align-items-center">
						<li>
							<h6>Coach Price</h6>
							<p class="primary-text">($150 * 3 hours)</p>
						</li>
						<li>
							<h6>Subtotal</h6>
							<p class="primary-text">$350.00</p>
						</li>
					</ul>
				</section>
				<div class="text-center btn-row">
					<router-link class="btn btn-primary me-3 btn-icon" to="/coaches/coach-personalinfo"><i class="feather-arrow-left-circle me-1"></i> Back</router-link>
					<router-link class="btn btn-secondary btn-icon" to="/coaches/coach-payment">Next <i class="feather-arrow-right-circle ms-1"></i></router-link>
				</div>
			</div>
			<!-- /Container -->
		</div>
		<!-- /Page Content -->

    <layout-footer></layout-footer>
</template>

<script>
export default {
    data() {
        return {
            title: 'Book A Coach',
            text: 'Home',
            text1: 'Book A Coach',
        }
    },
}
</script>